import _ from 'lodash';

export default {
  methods: {
    limitedServiceOptionsMixin(
      jobId,
      serviceDefinitions,
      allowDuplicateServices,
    ) {
      if (!serviceDefinitions) {
        return [];
      }
      const alreadySelectedServices =
        this.$store.getters.allSelectedServices(jobId);
      const useExternalNames = this.$store.getters.useExternalNames;
      const locale = this.$store.getters.locale;

      let disabledServices = [];
      let selectedInGroups = {};
      const userEditableForRoles = this.$store.getters.userEditableForRoles;

      alreadySelectedServices.forEach((selectedService) => {
        const serviceDef = serviceDefinitions[selectedService.service];
        if (!allowDuplicateServices) {
          disabledServices.push(selectedService.service);
        }
        if (serviceDef) {
          if (serviceDef.group_name[locale]) {
            selectedInGroups[serviceDef.group_name[locale]] =
              selectedService.service;
          }
        }
      });
      let options = [];
      let groupOptions = {};
      Object.values(serviceDefinitions).forEach((serviceDef) => {
        const groupName = serviceDef.group_name[locale];
        const disabled =
          serviceDef.editable_for.length &&
          serviceDef.editable_for.filter((role) =>
            userEditableForRoles.includes(role),
          ).length === 0;

        if (
          (disabled || serviceDef.legacy) &&
          !alreadySelectedServices.some(
            (service) => service.service === serviceDef.sfid,
          )
        ) {
          return;
        }
        const option = {
          value: serviceDef.sfid,
          text: groupName
            ? groupName
            : useExternalNames
            ? serviceDef.description[locale] || serviceDef.description.en
            : serviceDef.name,
          disabled: disabled || disabledServices.includes(serviceDef.sfid),
        };
        if (groupName) {
          if (!groupOptions[groupName]) {
            groupOptions[groupName] = [];
          }
          groupOptions[groupName].push(option);
        } else {
          options.push(option);
        }
      });
      Object.keys(groupOptions).forEach((groupName) => {
        if (selectedInGroups[groupName]) {
          options.push(
            groupOptions[groupName].find(
              (option) => option.value == selectedInGroups[groupName],
            ),
          );
        } else {
          const option = groupOptions[groupName][0];
          option.text = groupName;
          options.push(option);
        }
      });
      return options.sort((a, b) => {
        const aText = a.text || '-none-';
        const bText = b.text || '-none-';
        aText.localeCompare(bText);
      });
    },
  },
};
